import { useEffect, useState } from 'react';
import supabase from '../../services/supabase';
import { useAuth } from '../../components/auth/AuthContext';
import { useKeystoneAccess } from './useKeystoneAccess';

// Count of currently-flagged Keystone notes. Visible only to admin and
// keystone_leader; everyone else gets 0 so no badge renders.
//
// `refreshKey` (commonly `location.pathname`) lets the navbar refetch the
// count whenever the user navigates, so the badge drops as soon as a flag
// is actioned on the flagged-notes view.
export function useFlaggedKeystoneNotesCount(refreshKey?: unknown): number {
  const { user } = useAuth();
  const { isLeader } = useKeystoneAccess();
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (!user?.uid || !isLeader) {
      setCount(0);
      return;
    }

    let cancelled = false;

    const fetchCount = async () => {
      const { count: c, error } = await supabase
        .from('keystone_case_notes')
        .select('id', { count: 'exact', head: true })
        .eq('flagged_for_keystone_leader', true);
      if (!cancelled && !error) {
        setCount(c ?? 0);
      }
    };

    fetchCount();
    const interval = setInterval(fetchCount, 60_000);
    return () => {
      cancelled = true;
      clearInterval(interval);
    };
  }, [user?.uid, isLeader, refreshKey]);

  return count;
}
